module.exports = __webpack_public_path__ + "static/Q1Answer2_Hangingwithfriends_HelenaLopes-e7ba4b6ca15957ef0f7785af9025d74c.jpg";